const prefix = "[BRIEF_FORM]";

export default {
    FETCH_BRIEF_FORM_REQUEST: `${prefix} FETCH_BRIEF_FORM_REQUEST`,
    FETCH_BRIEF_FORM_SUCCESS: `${prefix} FETCH_BRIEF_FORM_SUCCESS`,
    FETCH_BRIEF_FORM_FAILED: `${prefix} FETCH_BRIEF_FORM_FAILED`,
    UPLOAD_BRIEF_FORM_ASSET_REQUEST: `${prefix} UPLOAD_BRIEF_FORM_ASSET_REQUEST`,
    UPLOAD_BRIEF_FORM_ASSET_SUCCESS: `${prefix} UPLOAD_BRIEF_FORM_ASSET_SUCCESS`,
    UPLOAD_BRIEF_FORM_ASSET_FAILED: `${prefix} UPLOAD_BRIEF_FORM_ASSET_FAILED`,
    UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_REQUEST: `${prefix} UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_REQUEST`,
    UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_SUCCESS: `${prefix} UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_SUCCESS`,
    UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_FAILED: `${prefix} UPLOAD_BRIEF_FORM_ADDITIONAL_ASSETS_FAILED`,
    REMOVE_BRIEF_FORM_ASSET_REQUEST: `${prefix} REMOVE_BRIEF_FORM_ASSET_REQUEST`,
    REMOVE_BRIEF_FORM_ASSET_SUCCESS: `${prefix} REMOVE_BRIEF_FORM_ASSET_SUCCESS`,
    REMOVE_BRIEF_FORM_ASSET_FAILED: `${prefix} REMOVE_BRIEF_FORM_ASSET_FAILED`,
    SUBMIT_BRIEF_FORM_REQUEST: `${prefix} SUBMIT_BRIEF_FORM_REQUEST`,
    SUBMIT_BRIEF_FORM_SUCCESS: `${prefix} SUBMIT_BRIEF_FORM_SUCCESS`,
    SUBMIT_BRIEF_FORM_FAILED: `${prefix} SUBMIT_BRIEF_FORM_FAILED`,
};
